import { seriesEsp, seriesEng, seriesId, groupsEsp, groupsEng } from "./translations/translations_frp_distribucion_renta.js";
import { translateSeries } from "../lib/translate_series_name.js";

export default class Visualizer {
  series = [];
  charts = [];

  RANGES_DEFAULT = [];
  CHARTS_DEFAULT = [];

  constructor(params) {
    this.charts = params || [];
    this.setDefaults();

    return {
      charts: this.charts.map((x) =>
        Object.assign(
          this.CHARTS_DEFAULT.find((y) => y.type == x.type),
          x
        )
      ),
      ranges: this.RANGES_DEFAULT,
      endpoints: {
        series: this.series,
        data: {
          build: () => {
            const sql = "SELECT * FROM distribucion_renta ORDER BY year";
            const gobiertoPath = process.env.GOBIERTO_DATA_URL;
            const token = process.env.GOBIERTO_DATA_TOKEN;
            const query = `?sql=${sql}&token=${token}`;

            return `${gobiertoPath}/api/v1/data/data.json${query}`;
          },
          parse: (data) => {
            this.series = translateSeries(this.series, seriesEsp, seriesEng, seriesId, null, null, groupsEsp, groupsEng);
            const series = this.series.map((d) => ({
              id: d.id,
              name: d.name,
              units: d.units,
            }));

            // reorder the return data to be grouped by kind of serie
            const groupBySerie = series.map((set) => {
              return data.data.map((d) => ({
                serie: set.id,
                time: new Date(d["year"], 0, 1),
                value: parseFloat(d[set.id]),
                name: set.name,
                units: set.units,
                idTooltip: "dr",
              }));
            });

            // give a flatted array
            return groupBySerie.flat();
          },
        },
      },
    };
  }

  setDefaults = () => {
    const series = [
      {
        "id": "c0_gini",
        "name": "Gini",
        "units": "",
        "group": "El indice de Gini y la remuneración bruta de la propiedad (% PIB)"
      },
      {
        "id": "c0_remuneracion_bruta_de_la_propiedad_pib",
        "name": "Remuneración bruta de la propiedad (% PIB)*",
        "units": "",
        "group": "El indice de Gini y la remuneración bruta de la propiedad (% PIB)"
      },
      {
        "id": "c1_gini_a",
        "name": "Gini A",
        "units": "",
        "group": "El índice de Gini y su composición*, 1850-2023"
      },
      {
        "id": "c1_gini_b",
        "name": "Gini B",
        "units": "",
        "group": "El índice de Gini y su composición*, 1850-2023"
      },
      {
        "id": "c1_l",
        "name": "L",
        "units": "",
        "group": "El índice de Gini y su composición*, 1850-2023"
      }
    ];

    if (this.charts[0].group) {
      const arrayOfGroup = this.charts[0].group;
      this.series = series.filter((d) => arrayOfGroup.includes(d.group));
    } else {
      this.series = series;
    }

    const range = (start, stop, step = 1) =>
      Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step);
    this.RANGES_DEFAULT = range(1850, 2023);

    this.CHARTS_DEFAULT = [
      {
        type: "Line",
        btnPlaceholder: "Añadir serie",
        xAxisProp: "time",
        yAxisProp: "value",
        aggregationProp: "serie",
        tooltip: this.tooltipCommon,
        language: "es",
        cache: true,
        tickFormatY: (...args) => {
          const [d, , , d3] = args;

          return d < 1e3 ? d3.format("")(d) : d3.format("~s")(d);
        },
      },
      {
        type: "Stacked",
        btnPlaceholder: "Añadir serie",
        xAxisProp: "time",
        yAxisProp: "value",
        aggregationProp: "serie",
        tooltip: this.tooltipCommon,
        language: "es",
        cache: true,
        tickFormatY: (...args) => {
          const [d, , , d3] = args;

          return d < 1e3 ? d3.format("")(d) : d3.format("~s")(d);
        },
      },
    ];
  };

  getScale(key, d3) {
    const scales = {
      linear: d3.scaleLinear(),
      log: d3.scaleLog(),
      pow: d3.scalePow(),
    };

    if (scales.hasOwnProperty(key)) {
      return scales[key];
    } else {
      return scales[0];
    }
  }
}
